<template>
  <div ref="box" class="plugin-box none-border record">
    <h2 class="center">{{ $t('海澳 PTE 真考查小分插件') }}</h2>
    <p class="center margin-t st margin-x">{{ $t('全面支持新版PTE成绩单，小分与详情清晰直观，一键导入生成分析报告，快速识别优势与短板，科学规划备考方向，让提分更高效、更有针对性！')
      }}
    </p>
    <div class="flex margin-lt">
      <div class="margin-r flex1">
        <plugin-popup :zoom="0.65"></plugin-popup>
      </div>

      <div class="margin-l flex1" style="display: flex;flex-direction: column;justify-content: space-between;">

        <div>

          <p class="dot1">{{ $t('最新适配 面向 2025.08.07 大改版的 PTE 成绩单，字段/题型/分项全覆盖；系统一更新即可配置同步，开箱即用，立刻上手！') }}</p>
          <p class="dot1 margin-t">{{ $t('结果更清晰 小分＋详情双面板，听说读写与题型供分/得分/波动一屏尽览；关键数据高亮，差距与机会点一眼锁定！') }}</p>
          <p class="dot1 margin-t">{{ $t('操作与导入 只需安装插件并打开 PTE 成绩页面，小分分析即可自动显示。无需手动录入或导入，细节即时呈现，助你快速发现差距。') }}</p>

          <p class="dot1 margin-t">{{ $t('科学备考 系统根据成绩与题型分布生成面板，直观展示强项与弱项。分析虽不替代练习，但能指明方向，让备考更高效。') }}</p>
        </div>

        <div>

          <div class="center margin-t">
            <el-button class="btn" @click="open('chrome')" type="primary"><img class="logo"
                src="/web/image/plugin/chrome.png" />{{ $t('从 Chrome Web Store 安装') }}</el-button>

          </div>

          <div class="center  margin-t">
            <el-button class="btn" @click="open('edge')" type="primary"><img class="logo"
                src="/web/image/plugin/Edge.png" /> {{ $t('从 Edge Add-ons 安装') }}</el-button>
          </div>

          <div class="center margin-t" style="margin-bottom: -8px;">
            <el-button class="btn" @click="open()" type="primary"><img class="logo"
                src="/web/image/plugin/download-fill.png" /> {{ $t('下载 Chrome/Edge 插件安装包手动安装') }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <h2 class="center margin-lt">{{ $t('安装说明') }}</h2>
    <el-card class="margin-t">
      <iframe style="width: 100%;height: 600px;border: none;" bord
        src="https://sns-video-qc.xhscdn.com/stream/1/110/114/01e8cd2469389728010370019961582aff_114.mp4?sign=2be513d253c44f649d4191dfe6e86e26&t=6a0b5181"></iframe>
      <!-- <video style="width: 100%;height: 400px;" controls
        src="https://www.xiaohongshu.com/discovery/item/68cd24aa000000001300b9d1?source=webshare&xhsshare=pc_web&xsec_token=YBtxSqsrpdmhjK7iCpQnfkWe_TCV3oyj5MMOgiNAYRNNE=&xsec_source=pc_share"></video> -->
    </el-card>
  </div>
</template>

<script>
import pluginPopup from '../components/PluginPopup.vue';

export default {

  components: {
    pluginPopup
  },

  data: function () {
    return {

    }
  },
  created() {

  },

  mounted() {
  },


  methods: {
    open(flag) {
      let url = 'https://www.ptefighter.com/download/海澳PTE-真考查小分插件-0.0.3.zip'
      if (flag == 'edge') {
        url = 'https://microsoftedge.microsoft.com/addons/detail/%E6%B5%B7%E6%BE%B3pte%E7%9C%9F%E8%80%83%E6%9F%A5%E5%B0%8F%E5%88%86%E6%8F%92%E4%BB%B6/jonpcelbhjimeebohmpfbopajmbeheec'
      } else if (flag == 'chrome') {
        url = 'https://chromewebstore.google.com/detail/pte-sub-skill-by-pte-figh/mjbbgnkicecggpkbfogiicpijjppiold'
      }
      window.open(url)
    }
  },
};
</script>

<style scoped>
.plugin-box {
  width: 1060px;
  margin: 40px auto;
  position: relative;
  overflow-x: hidden;
}

.logo {
  height: 30px;
  width: auto;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}

.btn {
  width: 500px;
}

.dot1 {
  display: flex;
}

.dot1::before {
  flex-shrink: 0;
  margin-top: 6px;
  margin-right: 10px;
  content: ' ';
  width: 10px;
  height: 10px;
  background-color: #e6a13c;
  border-radius: 50%;
}
</style>
